import React from 'react';
import PropTypes from 'prop-types';
import TextButton from '@spothero/ui/text-button';
import Icon from 'common/icon/Icon';
import CitySchemaDesktop from './CitySchemaDesktop';
import SpotListAvailabilityDesktop from '../spot-list/SpotListAvailabilityDesktop';

const CityFeatureDesktop = ({
    city,
    isFetchComplete,
    numSpots,
    onShowInfoModal,
    isMonthly
}) => {
    const {
        display_name: title,
        description,
        short_description: shortDescription
    } = city;
    const displayTitle = `${title} ${(isMonthly) ? 'Monthly ' : ''}Parking`;

    return (
        <div className="CityFeature">
            <div className="detail">
                <div
                    itemScope
                    itemType="http://schema.org/Place"
                >
                    <h1 className="feature-heading">
                        <span>{displayTitle}</span>
                        <meta
                            itemProp="name"
                            content={title}
                        />
                        {city && description &&
                            <TextButton
                                className="feature-info-link"
                                onClick={onShowInfoModal}
                            >
                                <Icon name="info" />
                            </TextButton>
                        }
                    </h1>
                    {shortDescription &&
                        <p className="CityFeature-short-description">
                            <span dangerouslySetInnerHTML={{__html: shortDescription}} />
                            <TextButton onClick={onShowInfoModal}>
                                <small>[Read More...]</small>
                            </TextButton>
                        </p>
                    }
                    <CitySchemaDesktop
                        city={city}
                    />
                </div>
                <SpotListAvailabilityDesktop
                    isFetchComplete={isFetchComplete}
                    numSpots={numSpots}
                />
            </div>
        </div>
    );
};

CityFeatureDesktop.propTypes = {
    city: PropTypes.object.isRequired,
    isFetchComplete: PropTypes.bool.isRequired,
    isMonthly: PropTypes.bool.isRequired,
    numSpots: PropTypes.number.isRequired,
    onShowInfoModal: PropTypes.func.isRequired
};

export default CityFeatureDesktop;
